import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay/legacy';
import classNames from 'classnames';
import get from 'lodash.get';
import { connect } from 'react-redux';
import SiteNavItem from './SiteNavItem';

import styles from './SiteNav-style.scss';

export function SiteNav({
    viewer,
    isNavigationRefreshVariant,
    isNavigationHovered,
    onMouseEnter,
    onMouseLeave,
}) {
    const navigation = get(viewer, 'tradeNavigation') || get(viewer, 'navigation') || null;
    const wrapperClassName = classNames({
        [styles.navigationRefresh]: isNavigationRefreshVariant,
    });

    return (
        <nav className={wrapperClassName}>
            <ul className={styles.items}>
                {(get(navigation, 'modules') || []).map((module, index) => {
                    return (
                        <SiteNavItem
                            key={`nav-${module.serviceId}-position-${index}`}
                            navigationModule={module}
                            isNavigationHovered={isNavigationHovered}
                            onMouseEnter={onMouseEnter}
                            onMouseLeave={onMouseLeave}
                        />
                    );
                })}
            </ul>
        </nav>
    );
}

SiteNav.propTypes = {
    isNavigationRefreshVariant: PropTypes.bool,
    isNavigationHovered: PropTypes.bool,
    onMouseEnter: PropTypes.func,
    onMouseLeave: PropTypes.func,
    viewer: PropTypes.object,
};

const mapStateToProps = ({ header }) => {
    const { isNavigationRefreshVariant } = header;
    return {
        isNavigationRefreshVariant,
    };
};

export default createFragmentContainer(connect(mapStateToProps)(SiteNav), {
    viewer: graphql`
        fragment SiteNav_viewer on Viewer {
            navigation: navigation(rootId: $previewKey) @include(if: $fetchNav) {
                modules {
                    ...SiteNavItem_navigationModule
                    serviceId
                }
            }
            tradeNavigation: navigation(rootId: $previewKey, userType: TRADE)
                @include(if: $fetchTradeNav) {
                modules {
                    ...SiteNavItem_navigationModule
                    serviceId
                }
            }
        }
    `,
});
